<div class="container mt-4">
  <h2 class="mb-4">Reportes Semanales</h2>

  <div *ngIf="loading" class="text-center mt-5">
    <p>Cargando reportes semanales...</p>
  </div>

  <div *ngIf="!loading && reports.length === 0" class="text-center mt-5">
    <p>No hay reportes semanales generados todavía.</p>
  </div>

  <div *ngIf="!loading && reports.length > 0">
  <div *ngFor="let report of reports" class="card mb-3 shadow-sm">
    <div class="card-body">
      <h5 class="card-title">📅 Semana de {{ report.date }}</h5>
      <p class="card-text">
        Total de clientes: <strong>{{ report.totalClientes }}</strong>
      </p>
      <button class="btn btn-primary" (click)="openReport(report._id!)">
        Ver detalles
      </button>
    </div>
  </div>
</div>
</div>
